import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

type IconTypographyProps = {
  icon: React.JSX.Element;
  text: string;
  dataTestId?: string;
};

export const IconTypographyContainer = ({
  children
}: React.PropsWithChildren) => (
  <Grid container rowSpacing="8px">
    {children}
  </Grid>
);

export const IconTypography = ({
  icon,
  text,
  dataTestId
}: IconTypographyProps) => (
  <Grid item container direction="row" data-testid={dataTestId}>
    <Grid
      item
      sx={theme => ({
        display: 'flex',
        gap: '8px',
        '& .MuiSvgIcon-root': {
          color: theme.typography.body1.color
        }
      })}
    >
      {icon}
      <Typography sx={{ fontWeight: '600' }}>{text}</Typography>
    </Grid>
  </Grid>
);
